import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Left } from '../../../../components/Icon';
import { HBox, VBox } from '../../../../components/Box';
import { Modal, ModalControls } from '../../../../components/Modal';
import { Button } from '../../../../components/Buttons';

import { COLOR_BG_LIGHT } from '../../../../vars';
import { selectVehicleBulkActionsKanbanTaskName } from '../../selectors';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import styles from './MainModal.module.css';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';

const STATE = {
  addedProps: {},
  isAddSecondContact: false,
  download: true,
  sendToEmail: false,
  relation: null,
  contact: null,
  secondaryRelation: null,
  secondaryContact: null,
  extraEmail: null,
};

const Container = styled.div`
  font-size: 14px;
  .title {
    font-size: 14px;
  }

  strong {
    margin-bottom: 24px;
  }

  .search-top {
    position: fixed;
    top: 0px;
    width: 100%;
    height: 90px;
    padding: 15px;
    font-weight: 600;

    background-color: ${COLOR_BG_LIGHT};

    .list-result-label {
      font-weight: 500;
      width: 50px;
      margin: 5px;
      text-align: center;
      background-color: black;
      color: #fff;
    }
  }

  .mobile-btn-block {
    position: fixed;
    left: 0;
    bottom: 0;
    margin: 0;
    width: 100%;
    .modal-footer-button {
      margin: 0;
      display: flex;
      height: 70px;
      min-width: 50%;
    }
  }

  .message {
    max-width: 400px;
    margin: 10px 0;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class MainModalComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {}

  get isTransportKanban() {
    return [
      'Transport_in_eu',
      'Transport_out_eu',
      'Transport_in_eu_planned_1',
      'Transport_in_eu_planned_2',
      'Transport_in_eu_planned_3',
      'Transport_in_eu_planned_4',
      'Transport_in_eu_planned_5',
      'Transport_in_eu_planned_6',
      'Transport_in_eu_planned_7',
      'Transport_in_eu_planned_8',
      'Transport_in_eu_planned_9',
      'Transport_in_eu_planned_10',
      'Transport_out_eu_planned_1',
      'Transport_out_eu_planned_2',
      'Transport_out_eu_planned_3',
      'Transport_out_eu_planned_4',
      'Transport_out_eu_planned_5',
      'Transport_out_eu_planned_6',
      'Transport_out_eu_planned_7',
      'Transport_out_eu_planned_8',
      'Transport_out_eu_planned_9',
      'Transport_out_eu_planned_10',
      'IDWE_transport_in_nl_expected',
      'IDWE_transport_in_DLA24',
      'Transport_1_nl_in',
      'IDWE_transport_nl_out_combined',
      'IDWE_transport_nl_individual',
    ].includes(this.props.bulkActionTask);
  }

  showModal(action) {
    this.props.sendAction(action);
  }

  reset() {
    this.props.sendAction('close');
  }

  renderModalBulkActionButtons() {
    if (this.isTransportKanban) {
      console.log('this.props.bulkActionTask', this.props.bulkActionTask);
      return (
        <div className={styles.buttonGridContainer}>
          <ButtonComponent style={'ButtonSoftEditFullWidth'} onClick={() => this.showModal(this.props.bulkActionTask)}>
            {this.lbl('vehicle.overview.excel_card.add_properties')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftEditFullWidth'} onClick={() => this.showModal('showExcelModal')}>
            {this.lbl('vehicle.overview.excel_card.share_data')}
          </ButtonComponent>

          <ButtonComponent style={'ButtonSoftEditFullWidth'} onClick={() => this.showModal('showPrintCMRModal')}>
            {this.lbl('vehicle.overview.excel_card.print_cmr')}
          </ButtonComponent>
        </div>
      );
    }
    return (
      <div className={styles.buttonGridContainer}>
        <ButtonComponent style={'ButtonSoftEditFullWidth'} onClick={() => this.showModal('showDocumentModal')}>
          {this.lbl('vehicle.details.documents.modal.add')}
        </ButtonComponent>
        <ButtonComponent style={'ButtonSoftEditFullWidth'} onClick={() => this.showModal('showExtraCostsModal')}>
          {this.lbl('vehicle.overview.bulk_actions.add_extra_cost')}
        </ButtonComponent>
        <ButtonComponent style={'ButtonSoftEditFullWidth'} onClick={() => this.showModal('showExcelModal')}>
          {this.lbl('vehicle.overview.excel_card.share_data')}
        </ButtonComponent>

        <ButtonComponent style={'ButtonSoftEditFullWidth'} onClick={() => this.showModal('showAddToOrderModal')}>
          {this.lbl('vehicle.overview.excel_card.add_to_order')}
        </ButtonComponent>
        <ButtonComponent style={'ButtonSoftEditFullWidth'} onClick={() => this.showModal('showPrintCMRModal')}>
          {this.lbl('vehicle.overview.excel_card.print_cmr')}
        </ButtonComponent>
        <ButtonComponent style={'ButtonSoftEditFullWidth'} onClick={() => this.showModal('showCreateTransportModal')}>
          {this.lbl('vehicle.overview.create_transport')}
        </ButtonComponent>
      </div>
    );
  }

  render() {
    return (
      <Container>
        <HBox>
          {window.innerWidth <= 768 && (
            <HBox vCenter left className="search-top">
              <Left />
              {this.lbl('vehicle.overview.bulk_actions')}
              <p className="list-result-label">{this.props.vehicleIds?.length}</p>
            </HBox>
          )}
          <ModalComponent
            size={'modal-lg'}
            mobileView={this.props.mobileView}
            onClose={this.reset.bind(this)}
            title={this.lblStr('vehicle.overview.bulk_actions')}
          >
            <div className="message">
              <strong>{this.lbl('vehicle.overview.bulk_actions.modal.title')}</strong>
            </div>

            {this.renderModalBulkActionButtons()}

            {this.props.mobileView && (
              <div className={styles.buttonContainer}>
                <ButtonComponent style="ButtonSoftDelete" onClick={this.reset.bind(this)}>
                  {this.lbl('cancel')}
                </ButtonComponent>
              </div>
            )}

            {!this.props.mobileView && (
              <div className={styles.buttonContainer}>
                <ButtonComponent style="ButtonSoftDelete" onClick={this.reset.bind(this)}>
                  {this.lbl('cancel')}
                </ButtonComponent>
              </div>
            )}
          </ModalComponent>
        </HBox>
      </Container>
    );
  }
}

MainModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    bulkActionTask: selectVehicleBulkActionsKanbanTaskName(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const MainModal = compose(withConnect, withRouter, injectIntl)(MainModalComp);
